<template>
    <div class="papsi-wrapper">
        <div class="papsi-wrapper flex justify-between">
            <div>
                <h1 class="text-2xl font-semibold text-[#24723b]">Consideration Requests</h1>
                <p class="text-xs text-[#747474] mt-2">Home / Consideration Requests</p>
            </div>
            <div class="flex gap-2">
                <button  class="py-3 px-5 rounded-md text-sm  w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]" @click="activeBtn = 'Button1'" v-bind:class="{active: activeBtn === 'Button1' , notactive: activeBtn != 'Button1'}">Request Status</button>
                <button  class="py-3 px-5 rounded-md text-sm  w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]"  @click="filterForEndorsement()" v-bind:class="{active: activeBtn === 'Button2' , notactive: activeBtn != 'Button2'}">For Endorsement</button>
                <button  class="py-3 px-5 rounded-md text-sm  w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]"  @click="filterForApproval()" v-bind:class="{active: activeBtn === 'Button3' , notactive: activeBtn != 'Button3'}">For Approval</button>
            </div>
        </div>
    </div>
    <div class="mt-11">
        <div v-if="activeBtn === 'Button1'" class="grid grid-cols-11 w-full gap-3 mb-5 ">
            <input type="text" @input="isTyping = true, search = search.toUpperCase()" placeholder="Search" class="col-span-3 border-[#b7b8b7] border p-2 px-5 rounded-md  outline-none  text-[#535353] text-sm"  v-model="search">
            <select @change="consiFilter" class="w-[250px] border-[#b7b8b7] border  rounded-md   outline-none p-2 px-5  text-[#535353]  text-xs font-semibold" v-model="filtered">
                <option value="ALL">ALL</option>
                <option value="R">FOR RECOMMENDATION</option>
                <option value="P">FOR APPROVAL</option>
                <option value="A">APPROVED</option>
                <option value="D">DISAPPROVED</option>
                <option value="C">CANCELLED</option>
            </select>
        </div>
        <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
            <TableControl v-if="activeBtn === 'Button1'" :Action="true" :header="header" :column="column" :info="info" :VButton="true" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewButton"/>                
            <TableControl v-if="activeBtn === 'Button2'" :Action="true" :header="header" :column="column" :VButton="true" :info="data_endorsement" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewButton"/>
            <TableControl v-if="activeBtn === 'Button3'" :Action="true" :header="header" :column="column" :VButton="true" :info="data_approve" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewButton"/>                    
        </div>
    </div>

    <div v-if="ViewConsideration">
        <ViewConsideration 
            @CloseView="ViewConsideration = false" 
            @cancel="ViewConsideration = false" 
            @endorse="confirmvalidation"
            @approve="confirmvalidation"
            :Data="Data" 
            :activeBtn="activeBtn" 
            :Approval="false" 
            @NoteConsi="NoteConsideration"/>
    </div>

    <PromptComponent v-if="prompt" 
        :header="promptheader" 
        :header1="promptheader1" 
        :success="success" 
        @close="prompt = false"/>

    <ValidationPrompt v-if="validation"
        @yes="confirmedValidation" 
        @cancel="cancelValidation" 
        :header="promtHead" 
        :header1="promtBody" />

</template>
<script>
import _ from 'lodash';
import { defineComponent } from 'vue';
import TableControl from '.././TableControl/TableControl.vue' 
import ViewConsideration from '../modal/ConsiderFormControl.vue'
import ConsiReq from '@/services/consirequest';
import PromptComponent from '@/componentsv1/Prompt/PromptComponent.vue';
import ValidationPrompt from '@/componentsv1/Prompt/ValidationPrompt.vue';

    
export default defineComponent({
components:{
    TableControl,
    ViewConsideration,
    PromptComponent,
    ValidationPrompt
},
data(){ 
    return{
        prompt: false,
        success: false,
        promptheader: null,
        promtHead:'',
        promtBody:'',
        validation:false,
        isTyping:false,
        search:'',
        filtered: 'ALL',
        ViewConsideration: false,
        info: '',
        activeBtn: "Button1",
        test: '',
        Data:'',
        noteconsi:'',
        AllConsi:'',
        //REQUEST STATUS
        header:[
            {title:'Request No.'},
            {title:'Employee Name'},
            {title:'Date Applied'},
            {title:'Covered Date'},
            {title:'Status'},
            {title:'Action'},                  
        ],

        column:[
            'consi_no',
            'employee_name',
            'date_applied',
            'covered_date',
            'con_status',
        ],
        //NOTED REQUEST
        header1:[
            {title:'Request No.'},
            {title:'Employee Name'},
            {title:'Date Applied'},
            {title:'Covered Date'},
            {title:'Noted by'},
            {title:'Action'}, 
        ],
        columnConsiNoted:[
            'consi_no',
            'employee_name',
            'date_applied',
            'covered_date',
            'noted_by'
        
        ],
        consi_key: null,
        data_endorsement : '',
        data_approve : '',   
    }
    },
    watch: {
        search: _.debounce(function() {
        this.isTyping = false;
        }, 700),
        isTyping: function(value) {
        if (!value) {
            this.searchConsi()
        }
        }
},
mounted(){
    this.searchConsi()            
},
methods:{
    async searchConsi(){
        let that = this
        this.$emit("showLoader")
        that.AllConsi = ''
        that.info = ''
        await ConsiReq.searchConsiderationRequest(that.search).then(function(response){
            that.AllConsi = response.data.data
            that.info = response.data.data
        }).catch(function(){
            that.AllConsi = ''
            that.info = ''
        });
        this.$emit("hideLoader")
    },
    cancelValidation(){
        this.validation = false
    },
    confirmedValidation()
    {
        this.activeBtn === "Button2" ? this.endorseConsiderationRequest(this.consi_key) : this.approveConsiderationRequest(this.consi_key)
    },
    confirmvalidation(consi)
    {
        this.consi_key = consi

        if(this.activeBtn === "Button2")
        {
            this.promtHead      = "ENDORSE CONSIDERATION REQUEST"
            this.promtBody      = "Are you sure you want to endorse this consideration request?";
            this.validation     = true
        }
        else if(this.activeBtn === "Button3")
        {
            this.promtHead      = "APPROVE CONSIDERATION REQUEST"
            this.promtBody      = "Are you sure you want to approve this consideration request?";
            this.validation = true
        }
        
    },
    async endorseConsiderationRequest(consi_key){
        let that = this
        this.$emit("showLoader")
        await ConsiReq.endorseLeaveRequest(consi_key).then(async function(){
            that.ViewConsideration = false
            await that.searchConsi()
            that.filterForEndorsement()
            that.validation      = false
            that.success         = true
            that.promptheader    = "Consideration Successfully Endorsed"
            that.promptheader1   = "The consideration request have been saved and recorded in the system."
            that.prompt          =  true
        }).catch(function(error){
            that.validation      = false
            that.success         = false
            that.promptheader    = "ERROR"
            that.promptheader1   = error.response.data.message
            that.prompt          = true
        });
        this.$emit("hideLoader")
    },
    async approveConsiderationRequest(consi_key){
        let that = this
        this.$emit("showLoader")
        await ConsiReq.approveConsiderationRequest(consi_key).then(async function(){
            that.ViewConsideration = false
            await that.searchConsi()
            that.filterForApproval()
            that.validation      = false
            that.success         = true
            that.promptheader    = "Consideration Successfully Approved"
            that.promptheader1   = "This consideration request has been validated and no further action is required."
            that.prompt          =  true
        }).catch(function(error){
            that.validation      = false
            that.success         = false
            that.promptheader    = "ERROR"
            that.promptheader1   = error.response.data.message
            that.prompt          = true
        });
        this.$emit("hideLoader")
    },
    filterForEndorsement(){
        this.activeBtn = "Button2"
        this.data_endorsement = this.AllConsi.filter(x => x.con_noted_datetime === null && x.con_status === 'A')
    },
    filterForApproval(){
        this.activeBtn = "Button3"
        this.data_approve = this.AllConsi.filter(x => x.con_noted_datetime != null && x.con_status === 'A' && x.con_apv_datetime === null)
    },
    consiFilter(){
        if(this.filtered == 'ALL' ){
            this.info = this.AllConsi
            return
        }
        this.info = this.AllConsi.filter(status=>status.con_status == this.filtered)
    },
    ViewButton(row){
        this.ViewConsideration = true
        this.Data = row
    },
}
})
    </script>
    
    <style scoped>
    .active {
        color: #ffffff;
        background-color: #24723b;
      }
    .notactive {    
        background-color: #CCAF12;
        color: #ececec;
      }
      table tr{
        padding: 10px 10px;
      }
    </style>
    